import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { WARM_GREY, PageContextDefinition, useAppState, usePageEntity, PageEntityProvider, LayoutShell, SiteFooterLayout, UiConfig, UiProvider, ComponentSwapProvider } from '@shapeable/ui';
import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { LayoutStyles, YELLOW, YELLOW_DARK, YELLOW_ORANGE, themeOverrides } from '../theme';
import { LinkEntityButton } from './elements/link-entity-button';
import { FeedEntriesProvider } from '../gatsby/providers/feed-entries-provider';
import { PostsProvider } from '../gatsby/providers/posts-provider';


export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const [ appState, setAppState, patchAppState ] = useAppState();
  const defaultPageEntity = usePageEntity();

  const { pageEntity } = appState;
  
  const config: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    theme: themeOverrides,
    header: {
      showThemeMode: true,
      variant: 'default',
    },
    search: {
      isAvailable: false,
    },
    entity: {
      dataProviders: [
        FeedEntriesProvider, PostsProvider,
      ],
    },
    componentProps: {
      MenuItemLink: {
        colors: {
          hover: {
            text: YELLOW,
          },
          active: {
            border: YELLOW,
            text: YELLOW,
          }
        }
      }
    }
  }

  return (
    <PageEntityProvider value={pageEntity}>
    <ComponentSwapProvider value={{
        LinkEntityButton: LinkEntityButton,
      }}>
    <UiProvider value={config}>
      <My.Container
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer backgroundColor={WARM_GREY} />
      </My.Container>
    </UiProvider>
    </ComponentSwapProvider>
    </PageEntityProvider>
  );
  
  
};

Layout.defaultProps = LayoutDefaultProps;

